import React from "react";
import ComponentHeader from "./ComponentHeader";
import DashboardNewProgram from "../../svg/DashboardAddNewProgram.svg";
import { Dropdown } from "react-bootstrap";
import { format, isPast, parseISO } from "date-fns";
import { BsThreeDotsVertical } from "react-icons/bs";
import ApiConfig from "../../config/ApiConfig";
import { AiOutlineRightCircle, AiTwotoneCalendar } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";
import Loader from "../../commonComponent/Loader";
import WithScrollbar from "./WithScrollbar";
import { useState } from "react";
import { useEffect } from "react";
import { getActiveProgram, getAssignedProgram } from "../../services/ActivePrograms";
import { sortArrLatest } from "../../Utils/Helper";
import moment from "moment";

function Dash_Programs() {
  const [programs, setPrograms] = useState([])
  const navigate = useNavigate();
  const [isLoading, setLoader] = useState(true);


  useEffect(() => {
    const getProgramList = async () => {
      try {
        // Use Axios to send requests to both APIs concurrently
        const [response1, response2] = await Promise.all([
          getActiveProgram(),
          getAssignedProgram(),
        ]);

        // Check if the requests were successful
        if (response1.status !== 200 || response2.status !== 200) {
          throw new Error('Failed to fetch data');
        }

        // Access the data from the responses
        const result1 = response1.data?.data;
        const result2 = response2.data?.data;

        // Update state with the combined data
        let result = result1.concat(result2)
        let removeOldData = result.filter((value) => {
          if (!isPast(parseISO(value.endDate))) {
            return value;
          }
        });
        const res = removeOldData.filter((item) => {
          if (!item.isArchive) {
            return item;
          }
        })
        setPrograms(sortArrLatest(res));
        setLoader(false)
      } catch (error) {
        console.error('Error fetching data:', error);
        setLoader(false)
      }
    };

    getProgramList();
  }, []);

  const renderPrograms = (dt) => {
    return (
      <div key={dt._id} style={{ width: "270px", height: "150px" }}>
        <div
          className="pointer d-flex flex-column justify-content-between rounded position-relative"
          style={{
            // maxWidth:'300px',
            width: "100%",
            height: "100%",
            backgroundSize: "cover",
            boxShadow: "inset 0px -125px 30px -30px rgba(0,0,0,0.7)",
          }}
          onClick={() =>
            navigate("/activeprograminfo", {
              state: { program: dt },
            })
          }
        >
          <img
            src={`${ApiConfig.ImageUrl}programs/${dt.createdBy}/${dt.programImage}`}
            alt=""
            onError={(e)=>e.target.src = `${ApiConfig.ImageUrl}programs/${dt.updatedBy}/${dt.programImage}`}
            className="h-100 w-100 "
            style={{ position: "relative", zIndex: "-2" }}
          />

          <div className="position-absolute d-flex flex-column justify-content-end  top-0 w-100 h-100 p-3">
          {/* <div
            className="d-flex justify-content-end"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            {" "}
            <Dropdown drop="start">
              <Dropdown.Toggle
                style={{
                  backgroundColor: "transparent",
                  border: "none",
                  color: "white",
                }}
                className="custom"
                id="dropdown-basic"
              >
                <BsThreeDotsVertical />
              </Dropdown.Toggle>

              <Dropdown.Menu style={{position:'fixed'}}>
                <Dropdown.Item
                  onClick={() =>
                    navigate("/activeprograminfo", {
                      state: { program: dt },
                    })
                  }
                >
                  View Details
                </Dropdown.Item>
                <Dropdown.Item
                type="button"
                data-bs-toggle="modal"
                data-bs-target="#assignprogrammodal"
              >
                Update Program List
              </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div> */}

          <div>
            <p className="mb-3 text-white fs-5">{dt.name}</p>
            <p className="mb-0 text-white">
              <AiTwotoneCalendar className="mb-1" size={"1.5em"} />{" "}
              {/* {format(parseISO(new Date(dt.updatedAt)), "dd MMMM, yyyy")} */}
              {moment(new Date(dt.updatedAt ? dt.updatedAt : dt.createdAt )).format("DD MMMM, yyyy")}
            </p>
          </div>
        </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <ComponentHeader title={"Programs"} descript={""} />
      {isLoading ? (
        <Loader
          visible={isLoading}
          style={{ top: "-15px", position: "relative" }}
        />
      ) : programs.length > 0 ? (
        <div
          style={{ height: "190px" }}
          className={
            programs?.length > 0
              ? "Dash mb-5 d-flex flex-column justify-content-center align-items-start"
              : "Dash shadow rounded-4 mb-5 d-flex align-items-center"
          }
        >
          <WithScrollbar
            children={
              programs &&
              programs?.map((dt) => {
                return renderPrograms(dt);
              })
            }
          />
        </div>
      ) : (
        programs.length <= 0 && (
          <section className="d-flex align-items-center">
            <div
              style={{ height: "auto", overflowX: "scroll" }}
              className={
                programs?.length <= 0 &&
                "Dash scroller-custom shadow rounded-4 mb-5 d-flex align-items-center"
              }
            >
              <div className="pointer d-flex justify-content-start rounded align-items-center  p-3">
                <img src={DashboardNewProgram} alt="" />
                <p className="resFont">
                  No Programs yet.{" "}
                  <Link
                    to="/createactiveprogram"
                    style={{ color: "rgba(47, 156, 149, 1)" }}
                  >
                    Click here to add new programs.
                  </Link>
                </p>
              </div>
            </div>
            <AiOutlineRightCircle
              className="position-absolute end-0 me-4 mb-2"
              style={{
                backgroundColor: "rgba(217, 217, 217, 0.5)",
                borderRadius: "50%",
              }}
              size={"40px"}
              color="rgba(31, 126, 120, 1)"
            />
          </section>
        )
      )}

      {/* <AddPrograms
        members={carePrograms ? carePrograms : null}
        setMembers={setCarePrograms}
        programsList={programList}
        onClickEvent={postData}
      /> */}
    </>
  );
}

export default Dash_Programs;
